export default theme => ({
  root: {
    width: '100%',
    height: '100%',
    textAlign: 'center'
  },
  refresh: {
    marginTop: '16px'
  }
});